export const isTokenExpired = (token) => {
  if (!token) return true;

  const payload = JSON.parse(atob(token.split(".")[1]));

  if (!payload.exp) return true;

  const expirationDate = payload.exp * 1000;
  return Date.now() > expirationDate;
};

export const getToken = () => {
  const token = localStorage.getItem("session");
  if (!token || token === "null" || token === "undefined") {
    return null;
  }
  if (!isTokenExpired(token)) {
    return token;
  }
  return null;
};

export const getAuthorization = () => {
  const token = getToken();
  return token ? `Bearer ${token}` : null;
};

/**
 * Decode JWT token payload
 * @param {string} token - JWT token
 * @returns {Object|null} Decoded payload or null if invalid
 */
export const decodeToken = (token) => {
  if (!token) return null;
  
  try {
    const payload = JSON.parse(atob(token.split(".")[1]));
    return payload;
  } catch (error) {
    console.error('Error decoding token:', error);
    return null;
  }
};

/**
 * Get current token payload
 * @returns {Object|null} Current token payload or null
 */
export const getCurrentTokenPayload = () => {
  const token = getToken();
  return decodeToken(token);
};

/**
 * Check if current user is admin based on JWT token
 * @returns {boolean} True if user has isAdmin flag in JWT
 */
export const isCurrentUserAdmin = () => {
  const payload = getCurrentTokenPayload();
  return payload?.isAdmin === true;
};

